export interface FaqItem {
  question: string;
  answer: string;
}

export const FAQ_CONFIG: FaqItem[] = [
  {
    question: 'What is the AdFraud IOC-Database?',
    answer:
      "The publicly available AdFraud IOC-Database is Pixalate's open-source, weekly-updated list of the top 50 highest-risk ad fraud Indicators of Compromise (IOCs). AdFraud IOC-DB is powered by Pixalate's MRC-accredited ad fraud detection engine, which analyzes 183 billion global data points daily. It filters this massive dataset down to the 50 most critical threats, allowing sysadmins to easily integrate high-risk blocklists without overwhelming their infrastructure. The AdFraud IOC-DB reveals the top 50 IOCs observed across multiple supply-path touchpoints, including IP addresses (both IPv4 and IPv6), device IDs (mobile and CTV), datacenters, fraudulent Bundle IDs, MFA publishers, and delisted apps."
  },
  {
    question: 'What is the mission behind AdFraud IOC-DB?',
    answer:
      "AdFraud IOC-DB is dedicated to helping combat the spread of ad fraud, invalid traffic, and abusive activity in the digital advertising supply chain. The mission aligns with Pixalate's broader goal of identifying bad actors and safeguarding the digital advertising supply chain and consumers from IVT and abusive activity."
  },
  {
    question: 'Who is the AdFraud IOC-DB intended for?',
    answer:
      'The database is built for ad fraud researchers, publishers, sysadmins, security teams, and platform operators who need actionable threat intelligence to block high-risk endpoints in the ad supply chain. By publicly releasing a free, weekly-updated feed of the highest-risk threat indicators, Pixalate aims to arm Small to Mid-sized publishers (SMBs) and the ad-tech community with the enterprise-grade intelligence needed to safeguard the digital supply chain.'
  },
  {
    question: 'How often is the AdFraud IOC-DB updated?',
    answer:
      "The AdFraud IOC-DB is updated weekly, surfacing the top 50 highest-risk IOCs in each category based on ad volume from Pixalate's analysis of 183 billion global data points per day."
  },
  {
    question: 'How can I access the complete list of IOCs?',
    answer:
      "The AdFraud IOC-DB is available for free on Pixalate's website, where users can see the weekly top 50 IOCs across all eight categories."
  }
];
